import {apiClient} from "../apiInstance/DefaultApi";

const updateCsrf = (csrfToken) => {
  apiClient.defaults.headers.common[csrfToken.headerName] = csrfToken.value;
};
export default updateCsrf;